import { Button, Checkbox, Modal } from "semantic-ui-react"
import Select from 'react-select';
import { useEffect, useRef, useState } from "react";
import SelectEmployeeForDevice from "./SelectEmployeeForDevice";
import { ajaxPost } from "../../ajax";

export const EmployeeSelection = (props) => {
    const [selectAll, setSelectAll] = useState([])
    const [employeeIds, setEmployeeIds] = useState([])
    const [employeeList, setEmployeeList] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [searchQuery, setSearchQuery] = useState("")
    const [debouncedQuery, setDebouncedQuery] = useState('');
    const [filter, setFilter] = useState({})
    const [page, setPage] = useState(1)
    const [showAdvanceFilter, setShowAdvanceFilter] = useState(false)
    const [busy, setBusy] = useState(false)

    const filterRef = useRef(null)

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedQuery(searchQuery); // Update debounced query after delay
        }, 1000);

        return () => clearTimeout(timer);
    }, [searchQuery])

    useEffect(() => {
        loadEmployees(debouncedQuery);
    }, [debouncedQuery, page]);

    useEffect(() => {

        loadEmployees(debouncedQuery)
    }, [filter])

    const employeeSearchlist = (list) => {
        var employees = [];
        if (list != null) {
            list.map(x => {
                var fullname = x.LastName + ", " + x.FirstName + " " + x.MiddleName;

                return (
                    employees.push({ label: fullname, value: x._id })
                )
            })
        }
        return employees;
    }

    const onCheckboxChange = (event, ctr) => {
        setSelectAll(ctr.checked);
    }

    const handleSearchEmployeeChange = (value) => {
        setEmployeeIds(value);
        setSearchQuery("")
    }
    const handleSearchChange = (text) => {
        if (searchQuery !== text) {
            setSearchQuery(text);
        }
    }

    const loadEmployees = (search) => {
        setIsLoading(true)
        ajaxPost({
            url: "api/Employee/searchFilteredEmployee",
            data: {
                "Search": search,
                "includeDeleted": false,
                "startingIndex": 0,
                "itemCount": page * 20,
                "employeeIds": (employeeIds || []).map(x => x.value || x),
                "CompanyIDs": filter.companyIds,
                "DivisionIDs": filter.divisionIds,
                "DepartmentIDs": filter.departmentIds,
                "PositionIDs": filter.positionIds,
                "CityIDs": filter.locationIds,
                "CostCenterIDs": filter.costCenterIds,
            },
            onSuccess: data => {
                if (employeeIds !== undefined && employeeIds.length > 0) {
                    setEmployeeList([...employeeList, ...data.content])
                }
                else {
                    setEmployeeList(data.content);
                }
                setIsLoading(false)
            },
            finally: () => { }
        })
    }
    const handleScrollToBottom = () => {
        // Check if we're already loading new data or if all employees are already loaded
        if (!isLoading) {
            setPage(page + 1);
        }
    }

    const onFilterChanged = () => {
        setFilter({
            companyIds: filterRef.current.state.CompanyIds,
            divisionIds: filterRef.current.state.DivisionIds,
            departmentIds: filterRef.current.state.DepartmentIds,
            positionIds: filterRef.current.state.PositionIds,
            locationIds: filterRef.current.state.LocationIds,
            costCenterIds: filterRef.current.state.CostCenterIds,
        })

        setEmployeeList([])
        setEmployeeIds([]);
        setShowAdvanceFilter(false)
        setPage(1)
    }

    const onFilterOpen = () => {
        setShowAdvanceFilter(true)
    }

    const onFilterClosed = () => {
        setShowAdvanceFilter(false)
    }

    const handleAction = () => {
        setBusy(true)
        if (selectAll)
            props.onAction([], {
                "CompanyIDs": filter.companyIds,
                "DivisionIDs": filter.divisionIds,
                "DepartmentIDs": filter.departmentIds,
                "PositionIDs": filter.positionIds,
                "CityIDs": filter.locationIds,
                "CostCenterIDs": filter.costCenterIds,
            });
        else
            props.onAction(employeeList.filter(x => employeeIds.map(i => i.value).includes(x._id)).map(x => { return x.AccessNumber }), {});
    }

    return (<>
        <Modal open size='tiny'>
            <Modal.Header>{props.title}</Modal.Header>
            <Modal.Content>
                <Checkbox toggle
                    onChange={onCheckboxChange}
                    checked={selectAll}
                    label="Select all employees"
                />
                <div style={{ display: "flex", marginTop: "10px" }}>
                    <div style={{ width: "90%" }}>
                        <Select isDisabled={selectAll} placeholder='Employee'
                            isLoading={isLoading}
                            value={employeeIds}
                            onChange={handleSearchEmployeeChange.bind(this)}
                            options={employeeSearchlist(employeeList)}
                            onInputChange={handleSearchChange.bind(this)}
                            isMulti
                            onMenuScrollToBottom={handleScrollToBottom} />
                    </div>

                    <Button style={{ marginLeft: "10px", width: '36px', 'max-height': '36px', height: '36px' }}
                        size="mini"
                        icon="filter"
                        onClick={onFilterOpen}
                    />
                </div>

            </Modal.Content>
            <Modal.Actions>
                <Button basic icon='check' disabled={busy || (employeeIds.length === 0 && !selectAll)}
                    content={props.action} loading={busy} onClick={handleAction.bind(this)}>
                </Button>
                <Button basic icon='cancel' content='Cancel' onClick={props.onClose} disabled={busy}></Button>
            </Modal.Actions>
        </Modal>
        <SelectEmployeeForDevice
            open={showAdvanceFilter}
            ref={filterRef}
            action="Ok"
            onClose={onFilterClosed}
            onAction={onFilterChanged}
            title="Upload Filter"
            allowSelectAll={false}
            removeEmployeeFilter={true}
        />
    </>)
}